export default __webpack_public_path__ + "static/media/shoes1.97d1238e.jpeg";